import { config } from "./configs";

export { article, acknowledgementGateArticleIds } from "./article";
export { author, authorTypes } from "./author";
export { config } from "./configs";
export { section } from "./section";
export { topic } from "./topic";
export { newsletter } from "./newsletter";
export { application } from "./application";
export { paywall } from "./paywall";
export * as tracking from "./tracking";

export const data = {
  application: {
    goldthread: { domain: "www.goldthread2.com", entityId: "327250" },
    scmp: {
      domain: config.domain.scmp,
      entityId: "325477",
      entityUuid: "2695b2c9-96ef-4fe4-96f8-ba20d0a020b3",
    },
  },
  articleTypeEntityUuids: {
    Column: "012d7708-2959-4b2b-9031-23e3d025a08d",
    Letters: "c8774510-c0e0-4117-99a5-48c444acc219",
    Opinion: "175d77bc-2793-43ce-aa75-17d537ba2e51",
  },
  scmpDomains: {
    ABACUS: "abacusnews.com",
    GOLDTHREAD: "goldthread2.com",
    SCMP: "scmp.com",
    SCMP_STAGING: "scmp.tech",
  },
  topicList: {
    breaking_news: "Breaking",
    china: "China",
    coronavirus: "Coronavirus",
    hong_kong: "Hong Kong",
    scmp_exclusive: "SCMP Exclusive",
  } as Record<string, string>,
  youtube: {
    /* cspell: disable-next-line */
    mmaChannelId: "UCivB3CVSWoD5GEz6kTv2bGQ",
    /* cspell: disable-next-line */
    scmpChannelId: "UC4SUWizzKc1tptprBkWjX2Q",
    /* cspell: disable-next-line */
    styleChannelId: "UCtYYXR3QV_1mKdJNksfCRtQ",
  },
} as const;
